export default __webpack_public_path__ + "static/media/del.336693a8.jpg";